{
  "alerts": {
    "cantCreateProperty": "Error, unable to update the property information. Please try again later.",
    "cantCreateUser": "Error, unable to create user. Please try again later.",
    "cantCancelReservation": "Error, the reservation could not be canceled. Please try again later.",
    "cantCancelSubscription": "Error, the subscription could not be canceled. Please try again later.",
    "cantUpdate": "Error, unable to update the information. Please try again later.",
    "cantUpdateReservtion": "Error, unable to update the reservation. Please try again later or write to us.",
    "emailIsIncorrect": "The email address is incorrect. Please make sure that the entered address is typed correctly",
    "googlePlayServicesNotAvailable": "Google Play Services are not available on your device.",
    "locationNotEnabledDescription": "You need to enable location to be able to fulfill orders.",
    "locationNotEnabledTitle": "Enable Location",
    "mandatoryUpdateMessage": "There is an update available that must be installed.",
    "outdatedPaymentMethod": "The selected payment method is outdated. Update the payment method and try again",
    "paymentFailed": "An error occurred during the payment.\nPlease contact support or try again.",
    "sthWentWrong": "Error, something went wrong.\nPlease contact support or try again.",
    "unavailableLocalization": "Your localization is not yet available",
    "update": "Update",
    "updateTitle": "Update available",
    "userWithEmailAlreadyExists": "User with this email address already exists"
  },
  "common": {
    "accept": "Accept",
    "add": "Add",
    "added": "Added",
    "at": "at",
    "cancel": "Cancel",
    "chat": "Chat",
    "change": "Change",
    "choose": "Choose",
    "choosePhoto": "Choose photo",
    "chosen": "Chosen",
    "clear": "Clear",
    "close": "Close",
    "closePage": "Close page",
    "continue": "Continue",
    "date": "Date",
    "default": "Default",
    "delete": "Delete",
    "deleteService": "Delete %{service}",
    "details": "details",
    "discount": "Discount",
    "done": "Done",
    "edit": "Edit",
    "error": "Error",
    "email": "Email",
    "from": "From",
    "goBack": "Return",
    "help": "Help",
    "hi": "Hi! 👋",
    "hours": "hours",
    "id": "ID",
    "menu": "Menu",
    "name": "Name",
    "no": "No",
    "OK": "OK",
    "or": "Or",
    "order": "Order",
    "phone": "Phone number",
    "popular": "Popular",
    "price": "Price",
    "return": "Return",
    "save": "Save",
    "service": "Service",
    "skip": "Skip",
    "stripe": "Stripe",
    "takePhoto": "Take a photo",
    "time": "Time",
    "together": "Total",
    "tryAgain": "Try again",
    "understand": "I understand",
    "update": "Update",
    "whether": "Or",
    "yes": "Yes"
  },
  "components": {
    "drawer": {
      "aboutStepapp": "About Stepapp",
      "coupons": "Coupons",
      "covid19": "Our response to Covid-19",
      "covid19Response": "Our response to Covid-19",
      "downloadApp": "Download app",
      "help": "Help",
      "hey": "Hey! ",
      "heyYou": "Hey %{name}!",
      "payments": "Payment methods",
      "referAFriend": "Invite friends",
      "settings": "Settings",
      "showProfile": "Show profile",
      "support": "Support",
      "writeToUs": "Write to us"
    },
    "footer": {
      "about": "About us",
      "app": "Application",
      "blog": "Blog",
      "cancellationRules": "Cancellation policy",
      "cleaningPersonnel": "Cleaning personnel",
      "contact": "Contact",
      "contactHours": "Mon-Sat 9:30-18:00",
      "cookies": "We use cookies to ensure that our website functions properly.",
      "daysAgo": "days ago",
      "disclaimerPL": "Stepapp is Stepapp sp. z.o.o. registered in Warsaw in the Polish Court Register, using number 0000896336. NIP: 5252860294.",
      "disclaimerNO": "Stephome AS registered in Oslo.",
      "FAQ": "FAQ",
      "learnMore": "Learn more",
      "myths": "Cleaning Myths",
      "privacyPolicy": "Privacy Policy",
      "reviews": "Reviews",
      "safePayment": "Safe payments",
      "termsOfUse": "Terms of Use",
      "today": "today",
      "workers": "Cleaning Staff",
      "worthKnowing": "Good to know",
      "yesterday": "wczoraj"
    },
    "header": {
      "aboutStepapp": "About Stepapp",
      "coupons": "Coupons",
      "help": "Help",
      "inviteFriends": "Invite friends",
      "payments": "Payment methods",
      "profile": "Profile",
      "register": "Register",
      "services": "Services",
      "settings": "Settings",
      "showProfile": "Show profile",
      "signIn": "Sign in",
      "support": "Support",
      "writeToUs": "Write to us"
    },
    "input": {
      "placeholder": {
        "additionalInstructions": "Example: Please knock on the door instead of using the doorbell.",
        "addNote": "Add additional description (optional)",
        "addressFirstLine": "Address 1st line",
        "addressSecond": "Second address line",
        "addressSecondLine": "Address 2nd line",
        "apartmentNumber": "Apartment number",
        "city": "City",
        "companyName": "Company Name",
        "doorCode": "Door code",
        "email": "E-mail",
        "firstName": "First name",
        "homeDescription": "What should we focus on the most while providing the service",
        "housing": "Housing",
        "keyInfo": "Where will you leave the key? e.g. “The key will be under the purple plant pot, to the left of the door“",
        "lastName": "Last name",
        "NIPNumber": "Tax Identification Number",
        "postalCode": "Postal code",
        "propertyName": "Property name",
        "size": "Square meters",
        "street": "Street",
        "typeAddress": "Enter address"
      }
    },
    "houseAreaOutOfScope": {
      "houseAreaIsTooLarge": "The entered house area is too large.",
      "orderForLargerHouseArea": "Would you like to order cleaning for a larger area? Contact us!",
      "writeAndOrderCustomCleaning": "I want to order custom cleaning"
    },
    "paymentOptions": {
      "type_apple": "Apple Pay",
      "type_google": "Google Pay"
    },
    "shareCouponSheet": {
      "copy": "Copy",
      "description": "Get %{providerReward} for just registering a friend\n who places their first order. They will receive %{receiverReward} just for registering, thanks to you!",
      "discountExplanation": "Minimal order value - 100 zł.",
      "share": "Share",
      "shareMessage": "I'm sending you a %{codeValue} discount for your first cleaning in the Stepapp application. To use it, enter the code %{referralCode} when placing an order!\nOrder placement link: %{appUrl}",
      "title": "Good friends help you to Stepapp"
    },
    "tabBar": {
      "application": "Application",
      "calendar": "Calendar",
      "dashboard": "Order",
      "myHome": "Addresses",
      "openApp": "Open the application",
      "stepappApp": "Stepapp Application",
      "stepappAppDescription": "Download our mobile app to stay updated with your orders and never miss promotions or messages from our service!",
      "stepappMobileApp": "Stepapp\nmobile app"
    },
    "tabBar_Calendar": "Calendar",
    "tabBar_Dashboard": "Order",
    "tabBar_MyHome": "Addresses"
  },
  "dialogs": {
    "couponActivated": "Coupon added",
    "couponAdded": "Stepapp wallet was topped up with the amount of %{amount}",
    "couponCreditsAdded": "Your wallet has been topped up with new credits to be used in the Stepapp app.",
    "couponFindOtherAndTryAgain": "Or it is incorrect. Check for typos and try entering it again.",
    "couponInvalid": "The code \"%{coupon}\" is invalid or outdated.",
    "couponUsed": "The code has already been used",
    "later": "Later",
    "multiPersonServiceInfoMessage": "Remember that one booking is assigned to one service provider. If you are booking a service for more than one person, the same person will perform the services one after another. If you want to book a service for two people at the same time, you need to place two separate orders and mention it in the order notes.",
    "multiPersonServiceInfoTitle": "Information about services for more than 1 person",
    "negativeRateTitle": "Be sure to write us what we can change or improve. This will help us a lot!",
    "ofCourse": "Of course",
    "positiveRateTitle": "Super! 🤘 Please, ratę our\napp. We will be more than\ngrateful for your feedback!",
    "rateTitle": "Do you like using\nStepapp?"
  },
  "notifications": {
    "accountDeletion": {
      "description": "The procedure for deleting your account has begun. This may take up to 7 days.",
      "title": "Account in the process of being deleted"
    },
    "permissionDenied": {
      "camera": "You don't have permission to use the camera.",
      "cameraDescription": "Go to settings to allow the use of the camera.",
      "notifications": "Enable notifications in App Settings",
      "notificationsDescription": "We use notifications to provide you with timely updates related to orders. Without turning them on, the app may not work properly."
    }
  },
  "pages": {
    "auth": {
      "basicInfoDescription": "We only ask you for the necessary information.\nYour email address and last name will only be visible to us.",
      "registerInStepapp": "Register in Stepapp."
    },
    "chooseCard": {
      "addCard": "Add card",
      "addCardFailed": "Failed to add the card",
      "addCardFailedDescription": "Check the provided data or try again later",
      "cardRecurringPaymentsInfo": "Your card will be assigned to your Stepapp account and used for recurring services. You can always change it in the settings.",
      "cardNotSupportThisPayment": "Your card does not support this type of payment. Try adding a different card.",
      "chooseCard": "Select a card",
      "confirm": "Confirm",
      "newCard": "New card"
    },
    "serviceDateAndAddress": {
      "addAddress": "Add address",
      "addAddressDescription_cleaning": "Provide detailed information so that we can start the cleanup without a hitch.",
      "addAddressDescription_massage": "Provide detailed information so we can start the massage without any issues.",
      "addAddressDescription_other": "Provide detailed information so we can start the service without any issues.",
      "addressForm": {
        "address": "Street and house number",
        "addressSecond": "Second address line",
        "city": "City",
        "doorCode": "Gateway code",
        "iWillBeThere": "I'll be at home",
        "iWillLeaveTheKey": "I'll leave the key",
        "numberOrHousing": "Apartment number",
        "postalCode": "Postal code"
      },
      "chooseHour": "Select a time",
      "continueLabel": "Next - Summary and payment",
      "description": "Select a date and time to start the service",
      "howAreWeGoingToEnter": "How do we enter your apartment?",
      "howAreWeGoingToEnterDescription": "It's an optional piece of information that will help us do the cleanup without a hitch. You can always add it later.",
      "instructionsForArrival": "Instructions for arrival",
      "iWillBeThere": "I'll be at home",
      "iWillLeaveTheKey": "I'll leave the key",
      "provideAddress": "Enter the address",
      "provideAddressTitle": "Enter the service delivery address",
      "provideAddressToCheckAvailability": "Thanks to the address, we will be able to determine the availability of our services",
      "title": "When do we start?"
    },
    "serviceSummary": {
      "addCard": "Add card",
      "additionalServices": "Additional services",
      "address": "Address",
      "cancellationRules": "Cancellation Policy",
      "cancellationRulesDescription": "Cancel your reservation before %{date}, to avoid additional charges. Cancellations after this time will incur additional charges of up to 50% of the order value.",
      "cardDescription": "We will block the funds only 48 hours before the cleaning. However, the collection itself will not take place until the day of the cleaning.",
      "couponList": "List of coupons",
      "dateNotAvailable": "The date you selected is already unavailable. Please return to the calendar and choose a new cleaning date.",
      "description": "Review your order again and check that everything is correct",
      "doYouNeedVATInvoice": "Do you need a VAT invoice?",
      "enterCoupon": "Enter coupon",
      "haveCoupon": "Do you have a coupon?",
      "haveCouponDescription": "You can add a coupon after logging in or registering.",
      "howAreWeGoingToEnter": "How do we enter your apartment?",
      "instantPaymentCardDescription": "We will collect the entire amount as soon as you place your order, due to the fact that your order has less than 48 hours left until start.",
      "instantPaymentInfo": "Your card's funds will be charged immediately, as there are less than 48 hours left before the service starts.",
      "instantPaymentRules": "Your reservation will begin earlier than 48 hours from now. Cancellations after this time will incur additional charges of up to 50% of the order value.",
      "invoiceAdditionalEmail": "You can add an additional email address here for sending the invoice. If you leave the field blank, we will send the invoice to the email address associated with your account.",
      "invoiceBeforeSubmit": "You can only do this before placing the order.",
      "loginToViewDetails": "Log in or register to place an order",
      "nextSteps": "Next steps",
      "nextStepsDescription_cleaning": "Once you make a reservation, we will assign one of our wonderful cleaners available in your area. You'll meet her in the app before the cleaning begins.",
      "nextStepsDescription_massage": "After placing your booking, we will assign one of our massage therapists available in your area. You will get to know them in the app before the massage starts.",
      "nextStepsDescription_other": "After placing your booking, we will assign one of our employees available in your area. You will get to know them in the app before the service starts.",
      "pay_blik": "Pay with BLIK",
      "pay_przelewy24": "Pay with Przelewy24",
      "payNow": "Pay now",
      "payNowDescription": "Note that if you do order regular cleaning, we will ask you to add the card to your booking. However, you can still pay for your first cleaning with BLIK or Przelewy24. Unfortunately, we do not accept cash payments.",
      "SMSInfo": "We will send an sms code to the phone number you provided. Enter it to confirm your login or registration.",
      "startDate": "Start date",
      "title": "Summary",
      "total": "To be paid",
      "VATInvoice": "Invoice details",
      "VATInvoiceInfo": "You can add invoice details at the bottom of the order. Remember to do this <b>before placing the order</b>.",
      "wantToGetVATInvoice": "I want to receive a VAT invoice",
      "yourStepappWallet": "Your Stepapp Wallet"
    }
  },
  "screens": {
    "accommodation": {
      "description": "We need to know the type of your apartment to ensure the best experience in Stepapp",
      "title": "Where do you live?",
      "type_APARTMENT": "Apartment",
      "type_HOUSE": "House"
    },
    "appUpdate": {
      "description": "We have just introduced a new, long-awaited update to our system and application. There have been many changes, but below we present the most important ones:",
      "feature1": "[New] Ability to edit reservations from the app, adding new services.",
      "feature2": "[New] Ability to change the date from the app.",
      "feature3": "[New] Intelligent availability calendar",
      "feature4": "[New] Apple Pay/Google Pay payments.",
      "feature5": "[New] Easier payment management.",
      "title": "Hey! Welcome to Stepapp 2.0."
    },
    "auth": {
      "alreadyHaveAccount": "Already have an account?",
      "iHaveAccount": "I already have an account",
      "inWhichCity": "In which city would you like to check our services?",
      "letsStart": "Begin",
      "logIn": "Sign in",
      "logInWith": "Log in through %{provider}",
      "order": "Order service",
      "register": "Register",
      "welcomeMessage": "We will help you with household chores, so you can gain more free time every day!",
      "welcomeMessage1": "We will help you with your household chores,\nthanks to which you will gain",
      "welcomeMessage2": "more free\ntime",
      "welcomeMessage3": " every day!",
      "whereDoYouLive": "Where do you live?"
    },
    "bookedServices": {
      "downloadApp": "Download the Stepapp app",
      "emptyBookings": "You don't have any scheduled services. Request a service from Stepapp and put your home on autopilot!",
      "order": "Order service",
      "showCompleted": "Completed services",
      "toTrackProgress": ", to track the progress of your bookings in real time."
    },
    "calendar": {
      "additionalCardVerification": "Your card may require additional verification.",
      "cantFindDate": "Can't find a convenient date?",
      "failedCardPayment": "We couldn't process the payment from your card",
      "hide": "Hide",
      "notRegistered": "Here, as a registered user, you will be able to see your future bookings.",
      "paymentFailed": "We were unable to collect the payment",
      "paymentFailedDescription": "Update your payment method to avoid creating any arrears",
      "serviceScheduleInfo": "We only display the nearest scheduled appointments. Later appointments will appear after the first upcoming service is completed. If you wish to make changes to later dates,",
      "settlePayment": "Settle payment",
      "showLaterReservations": "Show more bookings",
      "title": "My bookings",
      "updatePayment": "Update your payment method",
      "writeToUs": "Write to us"
    },
    "cancelReservation": {
      "addDiscount": "Add it to your wallet in the 'Payments' tab, and the payment for your next service from this reservation will be reduced by %{discount}.",
      "cancelAllScheduledAppointments": "We will cancel all scheduled appointments from this subscription.",
      "cancelAppointment": "Cancel this appointment %{fee}",
      "cancelEntireSubscription": "Cancel the entire subscription %{fee}",
      "cancelReservation": "Cancel the reservation",
      "cancelSubscription": "Cancel subscription %{fee}",
      "cancelSingleReservationInSubscription": "You are canceling only one single appointment (%{date}). A new appointment will be generated according to your subscription frequency.",
      "cancelSubscriptionWithCost": "You can also cancel the entire subscription, but you will still incur a cost for canceling this appointment.",
      "cancelOrEditReservation": "You can cancel the entire reservation or change the date.",
      "confirmCancelReservation": "Cancel this appointment %{fee}",
      "confirmCancelSubscription": "Cancel the subscription %{fee}",
      "dontCancelAppointment": "I don't want to cancel the appointment",
      "dontCancelSubscription": "I don't want to cancel the subscription",
      "insteadOfPaying": "Instead of paying %{fee}, you can save %{discount}!",
      "maybeConsiderResubscribe": "Maybe you’d consider re-subscribing?",
      "newAddressDiscount": "Order cleaning at your new address with a discount.",
      "nextServiceDiscount": "-%{discount} off your next service.",
      "reservationCanceled": "Reservation canceled.",
      "serviceCancellation": "Service cancellation.",
      "specialOffer": "We've prepared a special offer for you.",
      "staySubscribed": "Stay subscribed and take advantage of the offer",
      "subscriptionCanceled": "Subscription canceled.",
      "weWantToImprove": "We always strive to improve, and your opinion matters.",
      "whyCancelReservation": "Why do you want to cancel the reservation?",
      "whyCancelSubscription": "Why do you want to cancel the subscription?",
      "cancelCause": {
        "haveBetterOffer": "I have a better offer",
        "movingToANewPlace": "I am moving to a new place",
        "noLongerNeedTheService": "I no longer need the services",
        "other": "Other",
        "problemWithPlatform": "I have a problem with the Stepapp platform",
        "problemWithWorker": "I have a problem with the assigned person",
        "serviceNotGoodEnough": "The service does not meet my expectations"
      }
    },
    "chat": {
      "writeMessage": "Write a message"
    },
    "completedServices": {
      "completed": "Finished",
      "emptyCompleted": "You don't have any completed services. Request a service from Stepapp and put your home on autopilot!",
      "title": "Completed Reservations"
    },
    "coupons": {
      "addCoupons": "Add to order",
      "description": "Do you have a discount code or a Stepapp wallet code?",
      "emptyCoupons": "No coupons available",
      "giveAndReceiveDiscount": "Give 40 zł, Receive 40 zł",
      "removeCoupons": "Remove from order",
      "shareMailSubject": "Stepapp",
      "shareMessage": "Hey, I got you 40 zł to spend on home services at Stepapp! %{voucherCode}",
      "title": "Coupons",
      "typeCode": "Enter code",
      "validTo": "Valid to %{date}",
      "walletFundsDescription": "Funds from the wallet will be used to pay for the next service",
      "yourDiscounts": "Your discounts"
    },
    "dashboard": {
      "articlesTitle": "Stepapp Blog",
      "bookNow": "Book now",
      "chooseCategory": "Choose a category",
      "chooseCity": "Choose a city",
      "couldntProcessPayment": "We couldn't process the payment for the cleaning",
      "hygiene": "Hygiene",
      "hygieneDescription": "We have strict hygiene standards and zero tolerance for breaking safety rules.",
      "insurance": "Liability insurance",
      "insuranceDescription": "Every order in Stepapp is covered by a liability insurance of 1 000 000 zł.",
      "liabilityInsurance": "Liability insurance of 1 million zł",
      "mostPopularServices": "Most popular services",
      "proposeCity": "Propose city",
      "reliability": "Reliability",
      "reliabilityDescription": "We verify the background and experience of every person who enters our clients' homes.",
      "reviewsWithRating": "%{reviews} reviews with an average %{rating}/5",
      "secureOnlineBooking": "Secure online booking",
      "seeAllReviews": "See all reviews",
      "seeMore": "See more",
      "servicesWithName": "Hi, 👋🏻 how can we give you more freedom today?",
      "startingPrice": "from %{price} zł",
      "testimonials": "reviews",
      "title": "Order for",
      "trainedProfessionals": "Only trained professionals",
      "yourSafetyPriority": "Your safety is our priority.",
      "verifiedAndTrained": "We check and train all Stepapp professionals"
    },
    "category": {
      "chooseYourService": "Choose your service",
      "contactCustomerSupport": "Contact our Customer Support Department.",
      "easyOnlineBooking": "Easy and quick online booking",
      "haveQuestions": "Do you have a question?",
      "liabilityInsurance": "Liability insurance up to 1,000,000 PLN",
      "otherCategories": "Other categories",
      "trainedProfessionals": "Trained professionals",
      "whatMakesUsDifferent": "What makes us stand out?"
    },
    "detailsForm": {
      "description": "Your name and email address will not be visible to others.",
      "title": "Complete the information."
    },
    "dismissBrowser": {
      "goBackToApp": "Go back to the application."
    },
    "editProfile": {
      "aboutMe": "About me",
      "changePhoto": "Change profile picture",
      "title": "Edit profile",
      "updateInfo": "Update Information"
    },
    "flatSize": {
      "description": "We need to know the square footage of your home, to display the appropriate prices to you",
      "title": "How many m2?",
      "unit": "m2"
    },
    "fullScreenNotification": {
      "reservationButtonTitle": "Check calendar",
      "reservationDescription": "Now you can see them in your calendar and control the progress of the work.",
      "reservationTitle": "Super! Your booking\nhas been accepted."
    },
    "homeDescription": {
      "description": "What you enter here will be passed on to your worker",
      "title": "Add instructions"
    },
    "homeEdit": {
      "addAddress": "Add address",
      "chooseFriendlyName": "Choose a friendly name, for example: 'Grandma Gienia's House.' This name is visible only to you.",
      "confirmDeleteProperty": "Are you sure you want to delete the property?",
      "deleteProperty": "Delete property",
      "editAddress": "Edit address",
      "exactAddress": "Exact Address",
      "homeType": "Home type",
      "notEditableNote": "You can change only part of the information",
      "postalCode": "Postal code",
      "provideInformation": "Provide accurate address details so that we can get to your home without any problems.",
      "surface": "Surface",
      "type_APARTMENT": "Apartment",
      "type_HOUSE": "House",
      "whatsImportantNote": "What is important in your home when it comes to household chores?"
    },
    "location": {
      "description": "We will check if Stepapp services are\navailable in your region.",
      "title": "Enter your zip code"
    },
    "login": {
      "alreadyRegistered": "Do you already have a Stepapp account?",
      "and": "and",
      "firstTime": "Are you with us for the first time?",
      "logInWithAccount": "Or log in to your account.",
      "noAccRegister": "You don't have a Stepapp account yet! It's high time to clean things up!",
      "orderFirstService": "Order your first service",
      "privacyPolicy": "Privacy policy",
      "registerTitle": "It's almost ready!\nLog in or register to place an order.",
      "registerYourAccount": "Or register a new account.",
      "selectingOneOfAbove": "By choosing one of the above, you accept our",
      "social_apple": "Continue by using Apple",
      "social_default": "Continue with phone number",
      "social_facebook": "Continue by using Facebook",
      "social_google": "Continue by using Google",
      "termsOfUse": "Terms of Use",
      "title": "Log in or register",
      "webRegisterTitle": "It's almost ready! Create a Stepapp account or log in."
    },
    "maintenance": {
      "maintenanceBreak": "Technical Break",
      "maintenanceContactInfo": "If you need to contact our support, chat with us on the website %{landingPageUrl} or email us at %{supportEmail}",
      "maintenanceInProgress": "We are in the process of a major system update; currently, our applications are unavailable."
    },
    "myHome": {
      "addInfo": "Add Information",
      "addressNote": "Add more information about your home so we can better accommodate your needs",
      "notRegistered": "Here, as a registered user, you will be able to add information about your home so that we can better understand your needs.",
      "st": "st",
      "title": "My addresses"
    },
    "notes": {
      "addNoteToOrder": "Add a note to the order...",
      "cleaningNotes_cleaning": "Cleaning notes",
      "cleaningNotes_massage": "Massage notes",
      "cleaningNotes_other": "Service notes",
      "exampleNote_cleaning": "“I have stone countertops in the kitchen”\n“I have black cabinet fronts that get easily smudged”",
      "exampleNote_massage": "“Please do a gentler back massage”\n“Please avoid the right knee after surgery”",
      "exampleNote_other": "“Please pay special attention to ...”",
      "notes": "Notes",
      "whatWeShouldKnow_cleaning": "Is there anything we should know to meet your expectations?",
      "whatWeShouldKnow_massage": "Is there anything we should know before starting the massage? E.g., list of past illnesses, etc.",
      "whatWeShouldKnow_other": "Provide all the information and instructions that will help us successfully complete the service"
    },
    "notAvailableLocation": {
      "notAvailableLocationDescription": "Our services are not available at this address. If you want us to appear - let us know!",
      "notAvailableLocationTtile": "Unfortunately, we are not available in this location",
      "proposeCity": "I want Stepapp in my neighborhood",
      "proposeCityTitle": "I want Stepapp"
    },
    "notificationsCheck": {
      "description": "Don't miss information about promotions and important news about your cleaning.",
      "enableNotifications": "Enable notifications",
      "secondDescription": "Enable notifications to receive information about the progress of your service.",
      "secondTitle": "Don't miss the news.",
      "title": "Want to know about discounts?"
    },
    "oneTimePasswordForm": {
      "description": "Enter the code from the SMS we sent to you at %{phoneNumber}",
      "sendAgain": "Resend",
      "sendAgainIn": "Resend (%{countdown}s.)",
      "title": "Enter code from sms"
    },
    "paymentFailed": {
      "description": "We have not been able to draw funds to\nactivate your subscription. Update\npayment method or write to us if\nyou want to change it or cancel it ",
      "title": "Payment failed"
    },
    "payments": {
      "cantRemoveCardDescription": "You have ongoing services. To remove the card, pay for the cleanings or contact support.",
      "cantRemoveCardTitle": "Cannot remove card",
      "credits": "Credits",
      "editPaymentInfo": "You can edit payment methods for specific reservations in the details of each reservation on the 'My Bookings' screen",
      "finalized": "Finished",
      "noTransactions": "No transactions",
      "paid": "Paid",
      "failed": "Failed",
      "savedCards": "Saved cards",
      "stepappWallet": "Stepapp Wallet: %{balance}",
      "title": "Payment methods",
      "transactionHistory": "Transaction history"
    },
    "phoneForm": {
      "description_login": "To which Stepapp account was registered",
      "description_register": "We need this so that we can enable you to be contacted about your reservation.",
      "title": "Enter your phone number"
    },
    "pickCity": {
      "changeCity": "Change city",
      "changeCountry": "Change country",
      "description": "Stepapp is currently available in the cities listed below.",
      "loginTitle": "Choose the city where you currently live.",
      "registerTitle": "Choose the city where you currently live."
    },
    "predefinedProfile": {
      "experienceTitle": "My experience...",
      "lastReviews": "Last reviews",
      "recommendationsTitle": "About me",
      "finishedJobs": "%{count} completed services",
      "customerReviews": "%{count} customer reviews",
      "learnMoreVerification": "Learn more about our verification and training process in Stepapp.",
      "readMore": "Read more",
      "weCareWhoComes": "We care about who enters your home.",
      "workerBadgeDescription_training": "%{name} has completed our training in quality, work rules, and hygiene.",
      "workerBadgeDescription_safety": "%{name} has been verified by us and meets our safety requirements.",
      "workerBadgeTitle_training": "Training",
      "workerBadgeTitle_safety": "Safety"
    },
    "profile": {
      "removeCard": "Remove card",
      "removeCardExplanation": "Removing the card will result in its removal from your account. It will no longer be available for payments.",
      "title": "Your Profile",
      "totalOrders_zero": "%{count} reservations",
      "totalOrders_one": "%{count} reservation",
      "totalOrders_few": "%{count} reservations",
      "totalOrders_other": "%{count} reservations"
    },
    "redeemCoupon": {
      "add": "Add",
      "creditTitle": "Enter recharge code",
      "voucherTitle": "Enter promo code"
    },
    "reviews": {
      "noReviews": "We couldn't fetch reviews. Please try again later.",
      "numberOfReviews": "Number of reviews",
      "onlyVerifiedReviews": "Only verified reviews",
      "orderCleaning": "Order cleaning",
      "trueReviews": "All our ratings were given by real customers after the service was performed.",
      "star": "Star",
      "star_plural": "Stars",
      "star_many": "Stars"
    },
    "service": {
      "additionalServices": "What else can we do for you?",
      "additionalServicesDescription": "You can adjust the frequency of additional services after the first order.",
      "addressExplanationForVerification": "Enter the address to verify the availability of our services. You can add additional information in the following steps.",
      "autocompleteInfo": "<0>Enter the full street name</0> to check the availability of our services. In the next steps, you can add additional information.",
      "averageCleaningTime_cleaning": "Approximate cleaning time",
      "averageCleaningTime_massage": "Approximate massage time",
      "averageCleaningTime_other": "Approximate service time",
      "averageCleaningTimeDescription": "This is an estimated cleaning time, as we know that every home is different. If it turns out that more time is needed on site, we will inform you in advance and ask for your acceptance.",
      "backToHome": "Return to home page",
      "changeAddress": "Change address",
      "chooseAddress": "Choose address",
      "chooseServiceAdjustedToYourNeeds": "Choose a service tailored to your needs",
      "happyCustomers": "Happy customers",
      "howOften": "How often?",
      "howOftenDescription": "Always the same trusted person. Try it without a notice period.",
      "includedInService": "Included in the service!",
      "loader": "Just a moment,\nwe process your order",
      "newAddress": "New address",
      "nextDataAddress": "Next - date and address",
      "pickOrCreateAddress": "Choose an address from saved homes or add a new one",
      "priceForService": "Price for the service",
      "reservationError": "Oops! Something went wrong",
      "reservationErrorDescription": "Try again later or contact\nour customer service department",
      "reservationSuccess": "Super! Your reservation\nhas been confirmed",
      "reservationSuccessDescription": "Now you can see it in your\ncalendar and control the progress of the work.",
      "reviews": "Reviews about Stepapp",
      "seeDetails": "See details",
      "seeLastReviews": "View recent reviews",
      "selectAvailableOptions": "Select available options to view order details",
      "serviceDateInfo": "Free date change up to %{hours} hours before the start of your reservation.",
      "serviceInsurance": "Your cleaning is insured for\nthe amount of %{amount}.",
      "serviceProtects": "Service is protected by",
      "serviceRange": "Service range",
      "showCalendar": "View calendar",
      "showMoreServices": "More additional services",
      "subscriptionExplanationForEdit": "Remember, you can modify regular cleaning later.",
      "whatKindOfServiceYouNeed": "What kind of service do you need?",
      "whatServiceIncludes": "What does the service include?",
      "whichAddress": "For which address are you ordering?",
      "whichAddressDescription": "Choose one of the saved addresses or add a new one."
    },
    "serviceAcceptedOverlay": {
      "thankYou": "Thank you!",
      "reviewSubmitted": "Your review has been submitted successfully. Every piece of feedback helps us improve our services."
    },
    "serviceCalendar": {
      "chooseHour": "Choose the time that suits you",
      "description": "Select a date and time to start the service",
      "title": "When do we start?"
    },
    "serviceCard": {
      "canceled": "Cancelled",
      "details": "Details",
      "rateAndAccept": "Rate and accept the work",
      "showProgress": "Check progress",
      "today": "Today",
      "type_oneTime": "One time",
      "type_subscription": "Subscription",
      "worker": "Worker"
    },
    "serviceConfirmation": {
      "completedServicePhoto": "The service has been completed. We took a photo to verify our presence at the location. It is visible only to you and our support team.",
      "doYouAcceptService": "Do you accept the service?",
      "report": "Report a problem"
    },
    "serviceDetails": {
      "additionalInfo": "Additional instructions for the worker",
      "addMoreServices": "Add more services",
      "calendarChangeDateInfo": "We will charge a fee if you change the date of a one-time service less than %{hoursBeforeFee} hours before the original appointment.",
      "cancellationRule": "You can cancel and edit the service up to %{hoursBeforeFee} hours before without a fee and receive a 100% refund. Canceling after this time may incur additional charges.",
      "cancellationRules": "Cancellation Policy",
      "cancelService": "Cancel this service",
      "changeServiceDetails_cleaning": "Change cleaning details",
      "changeServiceDetails_massage": "Change massage details",
      "changeServiceDetails_other": "Change service details",
      "changeDate": "Change date %{fee}",
      "changeDate2": "Change the date",
      "changeDateInfo": "You can change the date and time of the service for free up to %{hoursBeforeFee} hours before the reserved appointment time.",
      "changeDateIntercomMessage": "Good day, I would like to request to change the date of my reservation from ... to ...",
      "changeDetails": "Change details",
      "cantUpdateAdditionalService": "The additional service cannot be updated.",
      "chat": "Start Chat",
      "close": "Close",
      "confirmDeleteService": "Are you sure? The additional service will not be performed",
      "currentPrice": "Current price",
      "deleteService": "Delete %{service}?",
      "fee": "(fee %{fee})",
      "fetchReservationError": "Something went wrong while retrieving the details of your reservation. Please return to the reservation calendar and try again. If the problem persists, contact us.",
      "hour": "Hour",
      "hours": "Hours",
      "manage": "Manage",
      "newPrice": "New price",
      "orderFor": "Order for:",
      "paymentForm": "Payment form",
      "questionNotFound": "The question for update could not be found",
      "questionCantBeUpdated": "Sorry, but this answer can no longer be modified. To make changes, please contact customer support.",
      "service": "Service",
      "showCancellationRules": "View Our Cancellation Policy",
      "submitChangeConfirmation": "The service date has been saved!",
      "submitChangeLoader": "Just a moment, we're saving the changes",
      "submitDetailsConfirmation": "Changes to the service have been saved!",
      "subscriptionChangeDateInfo": "Subscribers have flexibility! For cleaning as part of the subscription, you can make changes free of charge up to 36 hours before the service!",
      "total": "Total",
      "totalPaymentInfo": "We will only collect the payment on the day of the cleaning, but we will pre-authorize the funds 48 hours prior to the appointment.",
      "type_oneTime": "One time",
      "type_subscription": "Subscription",
      "writeToUs": "write to us"
    },
    "serviceRating": {
      "addPublicReview": "Add a public review",
      "answersNotShared": "Answers will not be shared with the worker.",
      "asYourWorker": "As your worker?",
      "cleanLeaveRating": "Clean? Rate the work!",
      "doYouWantToKeep": "Do you want to keep",
      "enterText": "Enter text",
      "followedInstructions": "Did the worker follow your instructions?",
      "giveYouComment": "Give us you comments",
      "howDoYouRateYourExperience": "How do you rate your experience?",
      "keep": "Keep",
      "leaveOpinion": "Give feedback",
      "leaveOpinionAndRating": "Give feedback and leave rating",
      "leaveRating": "Leave rating",
      "newWorker_description": "You will see the new worker 48 hours before the next service starts",
      "newWorker_title": "OK, we will assign someone else to the next service",
      "optional": "Optional",
      "rating1": "Poor service quality",
      "rating2": "Poorly",
      "rating3": "The service did not meet my expectations",
      "rating4": "It was OK, but needs improvement",
      "rating5": "The service met my expectations 100%",
      "sorryToHearThat": "We are sorry to hear that",
      "touchStarsToLeaveReview": "Touch the stars to leave a review.",
      "wasOnTime": "Was the worker on time?",
      "wasPrepared": "Was the worker prepared for the work?",
      "wantTheSameWorkerAgain": "Do you want the same worker again?"
    },
    "serviceRealization": {
      "chat": "Chat",
      "checkAndConfirm": "Check and accept the results",
      "daysLeft": "%{daysLeft} day left",
      "daysLeft_plural": "%{daysLeft} days left",
      "info": "Info",
      "rateTheServiceWithin": "Rate the service within 7 days",
      "report": "Report",
      "serviceCompleted": "Service completed!",
      "serviceStatus": "Service status",
      "statusChoosen": "Worker assigned",
      "statusChoosenDescription": "We have selected a person who will perform the service in your home! For subscription services, it will always be the same person!",
      "statusInProgress": "Service in progress",
      "statusInProgressDescription": "The worker is already busy tidying up! Once the cleaning is finished, we will ask for your feedback!",
      "statusOnTheWay": "The worker is on the way",
      "statusOnTheWayDescription": "It's today! Soon, the worker will arrive to clean your home!",
      "statusWaitingForAccpetance": "Your order has been fulfilled!",
      "still": "still"
    },
    "serviceSummary": {
      "addCreditDebitCard": "Add Payment Card",
      "additionalServices": "Additional services",
      "cardPayment": "Payment by card",
      "changeCoupon": "Change coupon",
      "changeDate": "Change date",
      "confirmAndOrder": "Confirm and checkout",
      "choosePaymentMethod": "Choose a payment method",
      "coupon": "Coupon \"%{coupon}\"",
      "description": "Review your order again and check that everything is correct",
      "enterCoupon": "Enter coupon",
      "frequency_EVERY_MONTH": "Every month",
      "frequency_EVERY_TWO_WEEKS": "Every two weeks",
      "frequency_EVERY_WEEK": "Every week",
      "frequency_ONE_TIME": "One time",
      "grossPriceIncludingVAT": "The price above is the gross price, including VAT %{vat}%",
      "howOften": "How often?",
      "importantInformation": "Important infromation",
      "iWillBeThere": "I'll be at home",
      "logIn": "Sign in",
      "loginToViewDetails": "Log in or register to place an order",
      "orderingFor": "You order for",
      "orderingForDescription": "The information you provide will be saved in your profile as “My address”",
      "paidOnServiceDay": "Collection on the day of execution",
      "paymentMethod": "Payment method",
      "paymentNotice": "After placing the order, we will perform a verification payment in the amount of the order price. It will be refunded within a maximum of 10 minutes. The actual reservation fee will be charged only after the service is completed.",
      "paymentNow": "Payment Now",
      "paymentNowInfo": "For bookings with a deadline within 48 hours, we block the funds at the time of booking.",
      "paymentTerms": "The payment terms are available at %{link}",
      "recurringPayment": "Subsequent payments",
      "registerAndOrder": "Register and place an order",
      "sendSMSCode": "Send the code via SMS",
      "SMSInfo": "We will send an sms code to the phone number you provided. Enter it to confirm your login or registration.",
      "subscriptionDiscount": "Subscription discount",
      "title": "Summary",
      "toPay": "To pay",
      "total": "Total",
      "usedVoucher": "Used coupon",
      "wantEnterCoupon": "Want to add a coupon?",
      "webCardModalTitle": "This is the final step. Add the card and enjoy a clean home. 🏠",
      "webPaymentInfo": "The administrator of your Personal Data is Stepapp Sp. z.o.o. Stripe is the payment administrator. We will never collect funds without your prior consent, and you have a 7-day claim period on all transactions.",
      "whatIfSomethingsGoesWrong": "What if something goes wrong?",
      "whatIfSomethingsGoesWrongDescription": "If you are not satisfied with the service, we ensure that it will be redone by the most experienced people in our team. Free of charge, of course.",
      "whatNow": "What now?",
      "whatNowDescription": "Once your order is confirmed, we will match you with the best worker in the area based on your preferences. You will get to know him and be able to contact him 48 hours before the order starts.",
      "when": "When?",
      "yourCardWillBeLinkedTo": "Your card will be linked to your Stepapp account and used for future downloads of ordered services. You can always change it in the settings.",
      "yourDataIsSecureThanksTo": "Your data is safe with",
      "yourDataIsSecureThanksToStripe": "Your data is secure thanks to Stripe Ltd.",
      "yourStepappWallet": "Your Stepapp Wallet "
    },
    "settings": {
      "accountDeleted": "The account deletion procedure has been initiated. We need to check if you have any outstanding transactions. Your account and all related data will be deleted within 7 days.",
      "cancellationRules": "Cancellation Policy",
      "deleteAccount": "Delete account",
      "discountsAndPromotions": "E.g., discounts, deals, and special offers",
      "email": "Email address",
      "logOut": "Sign out",
      "notifications": "Notifications",
      "newsletterAndPromotions": "Newsletter and promotions",
      "others": "Other",
      "phoneNumber": "Phone number",
      "privacyPolicy": "Privacy Policy",
      "pushNotifications": "In-app notifications",
      "informationAboutReservation": "Includes: information about your bookings, messages from customer support",
      "reminderAboutReservation": "Includes: booking reminders, urgent messages from customer support",
      "removeAccountExplanation": "Your account will be deleted. This action cannot be undone.",
      "smsNotifications": "SMS notifications",
      "title": "Settings",
      "updateEmailAddress": "Update email address",
      "wantToChangePhoneNumber": "If you want to change your phone number,"
    },
    "support": {
      "call": "Call",
      "contactOptions": "Contact options:",
      "sendEmail": "Send e-mail",
      "startChat": "Start chat",
      "title": "Contact us"
    },
    "unmatched": {
      "description": "We couldn't find the page you're looking for. Try returning to the previous page or contact us for more information.",
      "title": "Oops,\nthere's nothing here..."
    },
    "welcome": {
      "customerSupportDescription": "We are available for you 7 days a week via chat and email, and we will address any issues you cannot resolve through the application.",
      "customerSupportTitle": "Customer support always available.",
      "letsStart": "Let's start!",
      "orderCleaningDescription": "Estimate the cleaning of your home, choose an available date, and order the service at any time, 24/7.",
      "orderCleaningTitle": "Easy and fast way to order cleaning.",
      "trustedTeamDescription": "Every cleaner at Stepapp has been examined during a several-day training and cleans according to specified rules and standards.",
      "trustedTeamTitle": "Trusted, experienced, and trained team."
    }
  },
  "validation": {
    "address": "Enter the correct address",
    "blank": "The field must not be empty",
    "city": "Enter the correct name of the city",
    "companyName": "Enter the company name",
    "date": "Select the start date of the service",
    "email": "Enter a valid email address",
    "firstName": "Enter your name",
    "homeType": "Select home type",
    "hour": "Select the start time of the service",
    "invalid": "Enter the correct data",
    "keyInfo": "Describe where you will leave the key",
    "lastName": "Enter your last name",
    "maxSurface": "The maximum supported areas is %{maxSize}m2",
    "minSurface": "The minimum area is %{minSize}m2",
    "nipNumber": "Enter the correct NIP code",
    "numberOrHousing": "Enter the apartment/house number",
    "phone": "Enter the correct phone number",
    "pickAddress": "Choose address",
    "pickOption": "Choose one of the options",
    "postalCode": "Enter the correct postal code",
    "required": "Required",
    "smsOrPhoneNumber": "Incorrect SMS code or phone number"
  },
  "verification": {
    "closePage": "This page will close automatically after 10 seconds",
    "paymentVerificationConfirmed": "Your payment has been confirmed",
    "paymentVerificationFailed": "The confirmation has failed",
    "retryVerification": "Try again or use another payment method."
  }
}
